'use client';

import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '@/lib/utils';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'group peer inline-flex h-4 w-8 shrink-0 cursor-pointer items-center rounded-3xl border transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed data-[state=checked]:bg-sage data-[state=checked]:border-sage data-[state=unchecked]:border-edge data-[state=unchecked]:bg-edge disabled:data-[state=unchecked]:border-edge disabled:data-[state=unchecked]:bg-edge disabled:data-[state=checked]:border-sage/80 disabled:data-[state=checked]:bg-sage/75 p-0.5',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-3 w-3 rounded-full shadow-md transition-all group-disabled:opacity-90',
        'data-[state=checked]:translate-x-[15px] data-[state=checked]:bg-white',
        'data-[state=unchecked]:translate-x-0 data-[state=unchecked]:bg-white',
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
